import * as React from 'react';

import { brandColors } from 'brandColors';
import { Page } from 'constants/pages';

interface Props {
  page: Page;
  disabled?: boolean;
  className?: string;
}

export const ItemIcon: React.FC<Props> = (props) => {
  const { page, disabled, className } = props;
  const { details } = page;

  if (!details || !details.icon) {
    return null;
  }

  const Icon = details.icon;

  return (
    <div
      className={`rounded-full w-10 h-10 ${
        disabled ? 'bg-gray-50' : `bg-${details.hoverColor}`
      } p-2 self-start ${className}`}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Icon fill={disabled ? brandColors.colors.gray[600] : details.color} style={{ width: 24 }} />
    </div>
  );
};
